import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";

export const useDeleteVariant = (id: string, variantId: string) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<void>({
    mutationFn: () =>
      dispatch(
        apiThatThrows.deleteTiVoVariant.action({
          params: { id, variantId },
        })
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providers"] });
      queryClient.invalidateQueries({ queryKey: ["publications"] });
      queryClient.invalidateQueries({ queryKey: ["provider", id] });
    },
  });
};
